import { apiFetch } from 'api/apiFetch';
import { COMMON_URLS } from '@insurancemenu/imenu-components-lib/dist/utils/urls';

export type RefreshTokenType = () => Promise<Response>;

export const refreshToken: RefreshTokenType = async () => {
  return apiFetch(`https://${COMMON_URLS.api}/aaa/Prod/refreshTokens`, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify({}),
  });
};
